import axios from 'axios'

export default {
  getCustomers(term) {
        return axios.get('/api/customers/lookup?name=' + encodeURIComponent(term));
  },
  getNotifications(id) {
    return axios.get(`/api/customers/${id}/notifications`);
  },
  getCustomersById(id) {
      return axios.get('/api/customers/lookup?customerId=' + id);
  }
}



// WEBPACK FOOTER //
// ./ClientApp/app/shared/components/customerselector/api.js